export default {
  transfer_types_lang: {
    disposition: 'Dyspozycja',
    provision: 'Prowizja',
    roll: 'Rolka'
  },
  transfer_types_list: [
    {
      name: 'Dyspozycja',
      value: 'disposition'
    },
    {
      name: 'Prowizja',
      value: 'provision'
    },
    {
      name: 'Rolka',
      value: 'roll'
    }
  ]
}
